import { cn } from "@/lib/utils";
import { X } from "lucide-react";

export default function WantedNotApplied() {
  return (
    <div
      className={cn(
        "absolute rounded-sm border-2 border-zinc-950/50 inset-0 flex items-center justify-center pointer-events-none z-1 bg-zinc-950/60 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 size-7"
      )}
    >
      <X className="w-6 h-6 text-white stroke-[3]" />
    </div>
  );
}
